import { MouseEvent } from 'react';
import { batch } from 'react-redux';
import styled from 'styled-components';

import { ListingType } from 'algolia-api/types/ListingType';
import { Icon } from 'components/Icon/Icon';
import { RouterLink } from 'components/Link/RouterLink';
import { H4 } from 'components/Text/H4';
import { bodyTextBase, colors } from 'theme/theme';
import { listingSearchHome } from 'utils/searchHomePages';

import {
  PopularSearchesBody,
  PopularSearchesContainer,
} from './PopularSearches.styles';

const POPULAR_SEARCHES_BY_LISTING_TYPE: Record<ListingType, string[]> = {
  ALL: [
    getText('Communications'),
    getText('Education'),
    getText('Marketing'),
    getText('Executive Director'),
    getText('Attorney'),
  ],
  JOB: [
    getText('Communications'),
    getText('Education'),
    getText('Marketing'),
    getText('Executive Director'),
    getText('Attorney'),
  ],
  INTERNSHIP: [
    getText('Psychology'),
    getText('Law'),
    getText('Legal'),
    getText('Summer'),
    getText('Policy'),
  ],
  VOLOP: [
    getText('Board member'),
    getText('Data analyst'),
    getText('Research'),
    getText('Health'),
    getText('Art'),
  ],
  ORG: [
    getText('Education'),
    getText('Human Rights'),
    getText('Mental Health'),
    getText('Immigration'),
    getText('Health'),
  ],
  GRAD_PROGRAM: [
    getText('Public Health'),
    getText('Psychology'),
    getText('Social work'),
    getText('Public Policy'),
    getText('Sustainability'),
  ],
};

const LinkWithIcon = styled.div`
  align-items: center;
  display: flex;
  gap: 12px;
`;

const StyledRouterLink = styled(RouterLink)`
  color: ${colors.lightContentGrey};
  ${bodyTextBase}
`;

type Props = {
  onSearch: (event: MouseEvent<HTMLElement>) => void;
  search: (query: string) => void;
  selectedType: ListingType;
  setQuery: (query: string) => void;
};

export function PopularSearches({
  selectedType,
  onSearch,
  search,
  setQuery,
}: Props) {
  return (
    <PopularSearchesContainer>
      <PopularSearchesBody>
        <H4 lineHeight={1} mb={0}>
          {getText('Popular searches')}
        </H4>
        {POPULAR_SEARCHES_BY_LISTING_TYPE[selectedType].map((ps: string) => (
          <LinkWithIcon key={`${selectedType}-${ps}`}>
            <Icon name="search" colorName="lightContentGrey" size={18} />
            <StyledRouterLink
              data-qa-id="mobile-header-search-link"
              to={{
                pathname: listingSearchHome(selectedType),
                search: `?q=${ps}`,
              }}
              state={{ searchFrom: 'Mobile Search Link' }}
              onClick={(event) => {
                batch(() => {
                  setQuery(ps);
                  search(ps);
                  onSearch(event);
                });
              }}
            >
              {ps}
            </StyledRouterLink>
          </LinkWithIcon>
        ))}
      </PopularSearchesBody>
    </PopularSearchesContainer>
  );
}
